/** Credits granted at signup for the free 3-minute pack. */
export const START_CREDITS = 180

/** True while the start pack is not fully spent (socket value may be null while loading). */
export function hasStartCreditsLeft(usedCredits: number | null): boolean {
  return usedCredits !== null && usedCredits < START_CREDITS
}

/** Whole free minutes still covered by the start pack, from used_credits. */
export function freeMinutesFromUsedCredits(usedCredits: number): number {
  if (usedCredits >= START_CREDITS) return 0
  const left = START_CREDITS - usedCredits
  if (left > 120) return 3
  if (left > 60) return 2
  if (left > 0) return 1
  return 0
}
